import { render, staticRenderFns } from "./QuotesHeader.vue?vue&type=template&id=78b6796b&scoped=true&"
import script from "./QuotesHeader.vue?vue&type=script&lang=js&"
export * from "./QuotesHeader.vue?vue&type=script&lang=js&"
import style0 from "./QuotesHeader.vue?vue&type=style&index=0&id=78b6796b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b6796b",
  null
  
)

export default component.exports